import { render, staticRenderFns } from "./annualPlafon.vue?vue&type=template&id=05516649&"
import script from "./annualPlafon.vue?vue&type=script&lang=js&"
export * from "./annualPlafon.vue?vue&type=script&lang=js&"
import style0 from "./annualPlafon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports